<template>
    <div class="order-completed">
        <div class="content">
            <h1>Order Completed</h1>
            <h3>Thank you for your order</h3>
            <div class="order-number-details">
                <span>Order number: </span>
                <span v-text="model.orderNumber"></span>
            </div>
             <div class="order-details">
                <div class="addressee-details" style="border-bottom: none;">
                    <div class="addressee-row">
                    <h3>Billing and shipment details</h3>
                    </div>
                    <div class="addressee-row">
                        <span>First name</span>
                        <span v-text="model.billingDetails.firstName"></span>
                    </div>
                    <div class="addressee-row">
                        <span>Last name</span>
                        <span v-text="model.billingDetails.lastName"></span>
                    </div>
                    <div class="addressee-row">
                        <span>Address</span>
                        <span v-text="model.billingDetails.address"></span>
                    </div>
                    <div class="addressee-row">
                        <span>Postal code</span>
                        <span v-text="model.billingDetails.postalCode"></span>
                    </div>
                    <div class="addressee-row">
                        <span>City</span>
                        <span v-text="model.billingDetails.city"></span>
                    </div>
                    <div class="addressee-row" v-if="model.billingDetails.region !== null">
                        <span>Region</span>
                        <span v-text="model.billingDetails.region"></span>
                    </div>          
                    <div class="addressee-row">
                        <span>Country</span>
                        <span v-text="model.billingDetails.country"></span>
                    </div>                                                                  
                </div>
            </div> 
         <div class="order-details">
                <div class="item-details" v-for="item in model.items" :key="item.itemId">
                    <span v-text="formatQuantity(item.quantity)"></span>
                    <span v-html="item.name"></span> 
                    <span v-text="formatPrice(item.price, model.currency)"></span>
                </div> 
                              
                <div class="total-details">
                    <div class="total-row">
                        <span>Subtotal</span>
                        <span v-text="formatPrice(model.summary.subtotal, model.currency)"></span>
                    </div>
                
                    <div class="total-row">
                        <span>Shipping</span>
                         <span v-text="formatPrice(model.summary.shipping, model.currency)"></span> 
                    </div>
                    <div class="total-row" v-if="model.summary.vat > 0">
                        <span>VAT deducted</span>
                        <div class="vat-details">
                            <span v-text="formatPrice(model.summary.vat, model.currency)"></span>
                        </div>
                    </div>
                     <div class="total-row" v-if="model.summary.vat === 0">
                        <span class="fraco">VAT is included</span>
                    </div>                   
                     <div class="total-row">
                        <span class="forte">Total</span>
                        <span v-text="formatTotalPrice(model.summary, model.currency)" class="forte"></span>
                    </div>   
                    <div class="total-row">
                        <span class="fraco" v-text="formatRecipient" style="margin: 0 auto;"></span>
                    </div>                                               
                </div>             
            </div>  
            <div class="details-footer">
                <span>10 % of your purchase is donated to Doctors Without Borders.</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "orderCompleted",
    data() {
        return {
            orderConfirmedModel: Object
        }
    },
    methods: {
        formatQuantity(quantity) {
            return quantity+' x ';
        },
        formatPrice(price, currency) {
            var localization = 'sv-SE';
            return new Intl.NumberFormat(localization, {
                style: 'currency',
                currency: currency ? currency : "SEK",
                minimumFractionDigits: 0
            })
            .format(price)
            .replace("kr", "SEK");
        },
        formatTotalPrice(total, currency) {
            if (this.model.summary.vat > 0) {
                return this.formatPrice(total.subtotal.toFixed(2), currency)
            }
            return this.formatPrice((total.subtotal+total.shipping+total.vat).toFixed(2), currency);
        },
        formatVatPercentage(vat) {
            return '('+vat + '%)';
        }
    },
    computed: {
        formatRecipient() {
            return 'An e-mail with this information has been sent to '+this.model.email;
        },
        model() {
            let result = this.$store.getters['CHECKOUT/GET_ORDER_CONFIRMATION_MODEL']
            if (result === null || result === undefined) {
              result = this.$store.getters['CHECKOUT/GET_ORDER_CONFIRMATION_MODEL_STORAGE']
              if (result === null || result === undefined) {
                window.location.href = '/'; 
              }
            }
            return result;
        }
    },
}
</script>

<style lang="postcss" scoped>
    div.order-number-details {
        margin: 7% auto 0 auto;
        display: flex;
        justify-content: center;
    }
    div.order-number-details span {
        font-weight: 300;
        margin: 0 20px;
    }
    div.order-completed {
        display: flex;
        justify-content: space-around;
    }
    div.order-completed div.content {
        margin: 7% auto 0 auto;
        text-align: center;
        width: 80%;
    }
    div.order-completed div.content h1 {
        margin:0;
        padding:0;
        font-family: 'Didot-Italic', 'Helvetica', sans-serif;
        font-weight: 400;
        font-size: 2.25em;
    }
    div.order-completed div.content h3 {
        margin:0;
        padding:0;
        font-family: 'Didot-Italic', 'Helvetica', sans-serif;
        font-weight: normal;
        font-size: 1.2em;
        line-height: 1.5em;
    }
    div.order-completed div.content div.details-footer {
        padding: 20px 20px;
        background-color: #787878;
        border-bottom: 1px solid #000;
        border-left: 1px solid #000;
        border-right: 1px solid #000;
        margin-bottom: 3em;
    }
    div.order-completed div.content div.details-footer span {
        color: #fff;
    }    
    div.order-completed div.content div.order-details {
        margin-top: 3%;
        padding: 0;
        border: 1px solid #000;
    }
    div.order-completed div.content div.order-details div.item-details {
        padding: 20px 20px;
        border-bottom: 1px solid #000;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
    }
    div.order-completed div.content div.order-details div.total-details {
        padding: 20px 20px;
        border-bottom: none;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
    }
    div.order-completed div.content div.order-details div.item-details span {
        margin: 0 10px;
    }        
    div.order-completed div.content div.order-details div.total-details div.total-row {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        width: 75%;
        margin: 10px auto;
    }
    div.order-completed div.content div.order-details div.total-details div.total-row span {
        display: block;
        margin: 0 10px;
    }
    div.order-completed div.content div.order-details div.total-details div.total-row span.forte {
        font-weight: 600;
        font-size: 1.2em;
    }
    div.order-completed div.content div.order-details div.total-details div.total-row span.fraco {
        font-weight: normal;
        font-size: 0.9em;
        font-style: italic;
    }      
    div.order-completed div.content div.order-details div.total-details div.total-row div.vat-details {
        display: flex;
        justify-content: space-between;
    }     
    div.order-completed div.content div.order-details div.addressee-details {
        padding: 20px 20px;
        border-bottom: 1px solid #000;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    div.order-completed div.content div.order-details div.addressee-details div.addressee-row {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        width: 75%;
        margin: 10px auto;
    } 
    div.order-completed div.content div.order-details div.addressee-details div.addressee-row span {
        display: block;
        margin: 0 10px;
        width: 100%;
        text-align: left;
    }
</style>